import { Radio as RadioA } from 'antd';
import cs from 'classnames';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './radio.module.css';

type P = ComponentProps<typeof RadioA>;

const Radio = ({ children, classNames, ...rest }: P) => {
  const { t } = useTranslation();

  return (
    <RadioA
      {...rest}
      classNames={
        typeof classNames === 'function'
          ? (info) => {
              const resolvedClassNames = classNames(info);

              return {
                ...resolvedClassNames,
                icon: cs(styles.icon, resolvedClassNames?.icon),
                label: cs(styles.label, resolvedClassNames?.label),
                root: cs(styles.radio, resolvedClassNames?.root),
              };
            }
          : {
              ...classNames,
              icon: cs(styles.icon, classNames?.icon),
              label: cs(styles.label, classNames?.label),
              root: cs(styles.radio, classNames?.root),
            }
      }
    >
      {typeof children === 'string' ? t(children) : children}
    </RadioA>
  );
};

export default Radio;
